export default class Hash {
    static get(key) {
        const params = new URLSearchParams(window.location.hash?.substring(1));
        return params.get(key);
    }

    static set(key, val) {
        const params = new URLSearchParams(window.location.hash?.substring(1));
        params.set(key, val);
        window.location.hash = params.toString();
    }

    static remove(key) {
        const params = new URLSearchParams(window.location.hash?.substring(1));
        params.delete(key);
        window.location.hash = params.toString();
    }
}
